// Define the type for PluraliseKey to restrict possible keys to a predefined set
export type PluraliseKey =
  | "ERROR"
  | "WARNING"
  | "ACTIVITY"
  | "CONTACT"
  | "DOCUMENT"
  | "ENTRY"
  | "MATTER"
  | "MATTER_BALANCE"
  | "MATTER_TYPE"
  | "MEMO"
  | "OPENING_BALANCE"
  | "PACKET"
  | "SAFE_CUSTODY_DOCUMENT"
  | "SAFE_CUSTODY_PACKET"
  | "STAFF"
  | "TASK"
  | "UNBILLED_DISBURSEMENT"
  | "UNBILLED_COST_RECOVERY"
  | "UNBILLED_EXPENSE"
  | "UNBILLED_TIME_AND_FEE";

// Define the singular and plural words for each key
export const singularWords = Object.freeze({
  ERROR: "Error",
  WARNING: "Warning",
  // card types
  ACTIVITY: "Activity Type",
  CONTACT: "Contact",
  DOCUMENT: "Document",
  ENTRY: "Entry",
  MATTER: "Matter",
  MATTER_BALANCE: "Matter Balance",
  MATTER_TYPE: "Matter Type",
  MEMO: "Memo",
  OPENING_BALANCE: "Opening Balance",
  PACKET: "Packet",
  SAFE_CUSTODY_DOCUMENT: "Safe Custody Document",
  SAFE_CUSTODY_PACKET: "Safe Custody Packet",
  STAFF: "Staff",
  TASK: "Task",
  UNBILLED_DISBURSEMENT: "Unbilled Disbursement",
  UNBILLED_COST_RECOVERY: "Unbilled Cost Recovery",
  UNBILLED_EXPENSE: "Unbilled Expense",
  UNBILLED_TIME_AND_FEE: "Unbilled Time and Fee",
});

export const pluralWords = Object.freeze({
  ERROR: "Errors",
  WARNING: "Warnings",
  // card types
  ACTIVITY: "Activity Types",
  CONTACT: "Contacts",
  DOCUMENT: "Documents",
  ENTRY: "Entries",
  MATTER: "Matters",
  MATTER_BALANCE: "Matter Balances",
  MATTER_TYPE: "Matter Types",
  MEMO: "Memos",
  OPENING_BALANCE: "Opening Balances",
  PACKET: "Packets",
  SAFE_CUSTODY_DOCUMENT: "Safe Custody Documents",
  SAFE_CUSTODY_PACKET: "Safe Custody Packets",
  STAFF: "Staff",
  TASK: "Tasks",
  UNBILLED_DISBURSEMENT: "Unbilled Disbursements",
  UNBILLED_COST_RECOVERY: "Unbilled Cost Recoveries",
  UNBILLED_EXPENSE: "Unbilled Expenses",
  UNBILLED_TIME_AND_FEE: "Unbilled Time and Fees",
});

// Define the headers mapping for each key
export const headers = Object.freeze({
  ERROR: "ERROR",
  WARNING: "WARNING",
  // card types
  ACTIVITY: "ACTIVITY",
  CONTACT: "CONTACT",
  DOCUMENT: "DOCUMENT",
  ENTRY: "ENTRY",
  MATTER: "MATTER",
  MATTER_BALANCE: "MATTER_BALANCE",
  MATTER_TYPE: "MATTER_TYPE",
  MEMO: "MEMO",
  OPENING_BALANCE: "OPENING_BALANCE",
  PACKET: "PACKET",
  SAFE_CUSTODY_DOCUMENT: "SAFE_CUSTODY_DOCUMENT",
  SAFE_CUSTODY_PACKET: "SAFE_CUSTODY_PACKET",
  STAFF: "STAFF",
  TASK: "TASK",
  UNBILLED_DISBURSEMENT: "UNBILLED_DISBURSEMENT",
  UNBILLED_COST_RECOVERY: "UNBILLED_COST_RECOVERY",
  UNBILLED_EXPENSE: "UNBILLED_EXPENSE",
  UNBILLED_TIME_AND_FEE: "UNBILLED_TIME_AND_FEE",
});
export const getRegionSpecificExpenseHeaderKey = (region: string): PluraliseKey => {
  switch (region) {
    case "AU":
      return "UNBILLED_DISBURSEMENT";
    case "GB":
      return "UNBILLED_COST_RECOVERY";
    case "US":
      return "UNBILLED_EXPENSE";
    default:
      return "UNBILLED_EXPENSE"; // default to US if region is not recognised
  }
};
